export function isFunction(x) {
    return typeof x === 'function';
}
